import AppColors from "../../colors/AppColors";
import {Card, CardContent, Typography, useMediaQuery} from "@material-ui/core";
import {NumberUtils} from "../../utils/NumberUtils";
import React from "react";
import {RootStateOrAny, useSelector} from "react-redux";
import {Constants} from "../../constants/Constants";
import RewardUtils from "../../utils/RewardUtils";
import {useTheme} from "@material-ui/core/styles";

export default function MaximumProfitOnWinView() {

    const costPerTicket = useSelector((state: RootStateOrAny) => state.appReducer[Constants.COST_PER_TICKET]);
    const betType = useSelector((state: RootStateOrAny) => state.appReducer[Constants.BET_TYPE]);
    const tickets = useSelector((state: RootStateOrAny) => state.appReducer[Constants.TICKETS] ?? []);
    const theme = useTheme();
    const inMobileMode = useMediaQuery(theme.breakpoints.down(300));
    const inputValue = NumberUtils.formatInThousands(parseFloat(costPerTicket as string) * RewardUtils.GameRewards['' + betType] * tickets.length).substring(0, 8);
    const result = inputValue.length > 1 ? inputValue + ' BTC' : '';

    return <Card
        style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            backgroundColor: AppColors.CARD_BACKGROUND_COLOR,
            borderRight: 'none'
        }}>
        <CardContent>
            <Typography
                align={"center"}
                style={{
                    color: AppColors.EASE_GRAY,
                    paddingBottom: 5,
                    fontSize: 12,
                    textAlign: "center",
                    fontWeight: 'bold',
                }}>MAXIMUM PROFIT ON WIN:</Typography>
            <input
                contentEditable={false}
                style={{
                    paddingTop: 10,
                    paddingBottom: 10,
                    fontWeight: 600,
                    fontSize: inMobileMode ? 20 : 40,
                    textAlign: 'center',
                    backgroundColor: AppColors.CARD_BACKGROUND_COLOR,
                    color: '#FF9900'
                }}
                value={result}
            />
        </CardContent>
    </Card>
}